<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
  >
    <div v-if="visible" class="modal-wrapper">
      <div
        class="content-wrap"
        :style="{
          backgroundImage: `url(
            'https://res.pandateacher.com/CAD45XR91630651549014.png'
          )`,
        }"
      >
        <div class="title-main">支付遇到困难？别担心～</div>
        <div class="title-sub">送你一节0元Python体验课！</div>
        <div class="desc">“ 风变福利官 ” 向你递上学习申请表</div>
        <div class="desc">请选择一个理由：</div>
        <div class="select-wrap">
          <div
            v-for="(item, index) in selects"
            :key="item"
            class="item"
            @click="activeIndex = index"
          >
            <div
              :class="{ active: index === activeIndex }"
              class="radio"
              :style="{
                backgroundColor: `${
                  index === activeIndex ? strategyData.free_theme_color : ''
                }`,
              }"
            >
              <img
                v-show="index === activeIndex"
                class="icon"
                src="../../assets/icon-confirm.svg"
                alt=""
              />
            </div>

            <div class="text">{{ item }}</div>
          </div>
        </div>
        <div
          class="btn-confirm"
          :style="{
            backgroundColor: `${strategyData.free_theme_color}`,
          }"
          @click="confirm"
        >
          立即免费申请
        </div>
        <div class="btn-cancel" @click="cancel">彻底放弃这次学习机会</div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class Repay extends Vue {
  @Prop({ type: Boolean }) visible!: false;
  @Prop({ type: Function }) cancel!: Function;
  @Prop({ type: Function }) confirm!: Function;
  @Prop({}) strategyData!: any;

  @Watch('visible')
  watchIsShow(newVal: boolean) {
    if (newVal) {
      this.getModalInfo();
    }
  }

  getModalInfo = () => {};
  selects = Object.freeze(['想先体验', '微信没绑卡', '不方便支付 ']);
  activeIndex = 0;

  onCancel = () => {
    this.cancel();
  };
  onConfirm = () => {
    this.confirm();
  };
}
</script>

<style lang="scss" scoped>
@import '../../styles/animation.scss';
.animated {
  animation-duration: 0.4s;
}
.fadeIn {
  animation-name: fadeIn;
}
.fadeOut {
  animation-name: fadeIn;
  animation-direction: reverse;
}
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
}
.content-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  height: 646px;
  background-size: cover;
}
.title-main {
  margin-top: 35px;
  color: #ffffff;
  font-weight: 300;
  font-size: 26px;
}
.title-sub {
  margin-top: 28px;
  margin-bottom: 58px;
  color: #ffd304;
  font-weight: 800;
  font-size: 30px;
}
.desc {
  margin-top: 8px;
  color: #7756fd;
  font-size: 24px;
}
.select-wrap {
  display: inline-block;
  // margin-top: 262px;

  .item {
    display: flex;
    align-items: center;
    margin-top: 24px;
  }

  .radio {
    width: 28px;
    height: 28px;
    border: 1px solid #a0a0a0;
    border-radius: 50%;

    &.active {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      .icon {
        width: 23px;
        height: 24px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
    }
  }
  .text {
    margin-left: 8px;
    color: #363636;
    font-size: 26px;
  }
}
.btn-confirm {
  width: 246px;
  height: 68px;
  margin-top: 40px;
  color: #fff;
  line-height: 68px;
  text-align: center;
  background: #312dd5;
  border-radius: 34px;
  animation: heartbeat 0.8s linear infinite;
}
.btn-cancel {
  margin-top: 48px;
  color: #061934;
  font-weight: 300;
  font-size: 21px;
  text-decoration: underline;
}
</style>